export const STATUS_NOT_READY = 'Not Ready';
export const STATUS_SYNCED = 'Synced';
export const STATUS_REJECTED = 'Rejected';
export const STATUS_INVALID = 'Invalid';
export const STATUS_UNKNOWN = 'Unknown';
export const STATUS_USER_DUPLICATE_ERROR = 'UserDuplicateError';
